module.exports = __webpack_public_path__ + "img/image (13).5cd16474.png";